export default "__VITE_ASSET__DJp18FQ9__"